// extracted by mini-css-extract-plugin
var _1 = "ApplicantMatchingWidgetFormFields-moduleApplicantMatchingWidgetFormFields__QXFk4";
var _2 = "ApplicantMatchingWidgetFormFields-modulefields__ah8t2 FormFieldsContainer-moduleFormFieldsContainer__u1JJu";
export { _1 as "ApplicantMatchingWidgetFormFields", _2 as "fields" }
